// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerMOTD_wrapper__vzr8E","close":"BannerMOTD_close__cRynd","infoAlert":"BannerMOTD_infoAlert__Vgeda"};